import { formatDateWithAbbreviatedMonth } from "@/utils/dateFormatter";
import type { EmployerUpdateRequestOpenSummary } from "@/models/responses/employer-update-request/employer-update-request-pre-check.response";

function mapStatusForDisplay(status: EmployerUpdateRequestOpenSummary["status"]) {
  switch (status) {
    case "PENDING_SYNC":
    case "SUBMITTED":
      return "Submitted";
    case "APPROVED":
      return "Approved";
    case "CLOSED":
      return "Closed — contact PenCom support if unresolved";
    default:
      return status;
  }
}

function describeRequestedChanges(request: EmployerUpdateRequestOpenSummary) {
  const changes: string[] = [];
  if (request.newRcNumber) changes.push("RC number");
  if (request.newName) changes.push("company name");
  if (request.newAddress) changes.push("address");
  if (request.newEmail) changes.push("email address");
  if (request.newContactPersonEmail) changes.push("contact person email");
  if (request.newContactPersonPhone) changes.push("contact person phone number");
  if (request.newContactPersonRole) changes.push("contact person role");
  return changes.join(", ");
}

interface PendingRequestCardProps {
  request: EmployerUpdateRequestOpenSummary;
}

const PendingRequestCard = ({ request }: PendingRequestCardProps) => {
  const requestedChanges = describeRequestedChanges(request);

  return (
    <div className="bg-white border border-stroke rounded-lg p-6 flex flex-col gap-y-4">
      <h3 className="font-clash-display font-semibold text-lg text-medium-dark-grey">
        You already have an update request in progress
      </h3>
      <p className="font-clash-display text-sm text-medium-dark-grey leading-[20px]">
        You&apos;ll be notified when it&apos;s resolved. Contact PenCom
        support if you need to amend it.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 bg-baby-blue rounded-lg p-4">
        {requestedChanges && (
          <div className="flex flex-col gap-1">
            <p className="font-clash-display text-xs text-medium-grey">
              What you requested
            </p>
            <p className="font-clash-display font-semibold text-sm text-medium-dark-grey">
              Correction to {requestedChanges}
            </p>
          </div>
        )}
        <div className="flex flex-col gap-1">
          <p className="font-clash-display text-xs text-medium-grey">
            Submitted on
          </p>
          <p className="font-clash-display font-semibold text-sm text-medium-dark-grey">
            {formatDateWithAbbreviatedMonth(request.createdAt)}
          </p>
        </div>
        <div className="flex flex-col gap-1">
          <p className="font-clash-display text-xs text-medium-grey">
            Current status
          </p>
          <p className="font-clash-display font-semibold text-sm text-medium-dark-grey">
            {mapStatusForDisplay(request.status)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PendingRequestCard;
